import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux'
import { message } from 'antd';
import ApiUtils from '../../flowable/ApiUtils';


const hasURI = (instance, uri) => {
  if (instance && Array.isArray(instance.variables) && instance.variables.length > 0){
    const items = instance.variables.filter(item => (item.name == "uri_semantic_element")&&(item.value == uri));
    //console.log("ProcessInstaceLink.js hasURI(instance, uri)", instance, uri, items);
    return items.length > 0;
  }
  return false;
}

/** Отображение ссылки на wiki статью
 * 1. Заголовок - название wiki вики статьи или URL (если ссылка на информацию о wiki ещё не считана). 
 * 2. Тело - обрезаное содержимое статьи
 * 
 * Входным прараметром является URI на wiki статью в liferay
 * */
class ProcessInstaceLink extends React.Component {
  state = {
    processInstances: [],  //Список процессов
    activities: [],       //Активные процессы 
    loading: true,
    IRI: undefined,
  }
  
  componentDidMount() {
    this.loadProcessInstances();
  }

  static getDerivedStateFromProps(props, state) {
    if ((props.IRI != state.IRI) && Array.isArray(state.processInstances) && Array.isArray(state.processInstances.data)){
      const activities = state.processInstances.data.filter(instance => hasURI(instance, this.props.IRI))
      return {processInstances: result.data, activities, loading: false, IRI: this.props.IRI};
    }
    return null;
  }

  loadProcessInstances() {
    ApiUtils.getProcessDefinitions()
      .then(result => {
        //console.log("ProcessInstaceLink.js loadProcessInstances()", result);
        if (result && result.data && Array.isArray(result.data.data)){
          const activities = result.data.data.filter(instance => hasURI(instance, this.props.IRI))
          this.setState({processInstances: result, loading: false, activities});
          return {processInstances: result.data, activities, loading: false, IRI: this.props.IRI};
        }
        return {processInstances: result, loading: false, IRI: this.props.IRI};
      }).catch( e => {
        this.setState({loading: false});
        message.error(`Ошибка при получении дополнительной информации и распространении элемента каталога. ${e}`)
        return Promise.reject(e);
      })
  };
    
  render() {
    const { processInstances } = this.state;
    let activities = [];
    if (processInstances && processInstances.data && Array.isArray(processInstances.data.data)){
      activities = processInstances.data.data.filter(instance => hasURI(instance, this.props.IRI));
      //console.log("!!!!!!!!", activities, this.props.IRI, JSON.stringify(activities));
    }
    //const { activities } = this.state;
    const hasActivities = (Array.isArray(activities))?activities.length>0 : false;
    //console.log(this, hasActivities, activities, this.props.IRI, processInstances.data);
    return (
      <div>
        {!hasActivities && <p><b>{i18n.t('views.adms.collaboration.lifecycle_none')}</b></p>}
        {hasActivities && <h3>Активные рабочие процессы</h3>}
				{hasActivities && (
					<ul style={{listStyle: "square"}}>
						{activities.map((instance, i)=> 
              <li key={i}>
                <a href={"http://62.61.8.56:9080/flowable-task/workflow/#/processes/"+instance.id} target="_blank">{instance.name} ({instance.id})</a><br/>
                <i>{instance.processDefinitionDescription}</i>
              </li>)
            }
					</ul>
				)}

      </div>
    );
  }
}

//Представление информации о этапе ЖЦ связанного с процессом в flowable 
export default connect(
  (state, props) => {
    const { vset } = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
    })
  },
  dispatch => ({
    onLoadDetailWikies (actions, values){
      return dispatch(actions.LOAD_WIKIES(values));
    },
  })
)(ProcessInstaceLink)
